import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    Grid,
    Typography,
} from '@mui/material'
import { AccountBalance } from '@mui/icons-material'

const currencyBRL = (n) =>
    (Number(n) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

const AccountSummaryCard = ({ account }) => (
    <Card
        component="a"
        href={`/financeiro/contas-bancarias/${account.id}/extrato`}
        sx={{
            height: '100%',
            border: '1px solid #E2E8F0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            borderLeft: `4px solid ${account.color || '#3B82F6'}`,
            transition: 'box-shadow 0.2s ease, transform 0.2s ease',
            textDecoration: 'none',
            display: 'block',
            '&:hover': {
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                transform: 'translateY(-2px)',
            },
        }}
    >
        <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Typography
                    variant="subtitle2"
                    sx={{ color: '#1E293B', fontWeight: 600, flex: 1 }}
                    noWrap
                >
                    {account.nickname || account.bank_name}
                </Typography>
                <Chip
                    label={account.data_source === 'automatic' ? 'Integrada' : 'Manual'}
                    size="small"
                    sx={{
                        bgcolor: account.data_source === 'automatic' ? '#22C55E14' : '#3B82F614',
                        color: account.data_source === 'automatic' ? '#22C55E' : '#3B82F6',
                        fontWeight: 600,
                        fontSize: '0.65rem',
                        height: 20,
                        border: `1px solid ${account.data_source === 'automatic' ? '#22C55E30' : '#3B82F630'}`,
                    }}
                />
            </Box>

            <Typography variant="caption" sx={{ color: '#94A3B8' }}>
                {account.bank_name}
            </Typography>

            <Typography
                variant="h6"
                sx={{
                    fontWeight: 700,
                    color: account.current_balance >= 0 ? '#1E293B' : '#EF4444',
                    mt: 1.5,
                }}
            >
                {currencyBRL(account.current_balance)}
            </Typography>

            <Chip
                label={account.account_type === 'savings' ? 'Poupanca' : 'Corrente'}
                size="small"
                sx={{
                    mt: 1,
                    bgcolor: `${account.color || '#3B82F6'}14`,
                    color: account.color || '#3B82F6',
                    fontWeight: 600,
                    fontSize: '0.7rem',
                    height: 22,
                    border: `1px solid ${account.color || '#3B82F6'}30`,
                }}
            />
        </CardContent>
    </Card>
)

const AccountsOverview = ({ accounts = [] }) => (
    <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: '#1E293B' }}>
                Contas Bancarias
            </Typography>
            <Button
                href="/financeiro/contas-bancarias"
                variant="text"
                size="small"
                sx={{ color: '#3B82F6', textTransform: 'none', fontWeight: 600 }}
            >
                Gerenciar →
            </Button>
        </Box>

        {accounts.length === 0 ? (
            <Card
                sx={{
                    border: '1px solid #E2E8F0',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                    borderRadius: 3,
                }}
            >
                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <AccountBalance sx={{ fontSize: 40, color: '#E2E8F0', mb: 1 }} />
                    <Typography variant="body2" sx={{ color: '#94A3B8', mb: 2 }}>
                        Nenhuma conta bancaria cadastrada
                    </Typography>
                    <Button
                        href="/financeiro/contas-bancarias"
                        variant="outlined"
                        size="small"
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            borderRadius: 2,
                            borderColor: '#E2E8F0',
                            color: '#3B82F6',
                        }}
                    >
                        Adicionar Conta
                    </Button>
                </CardContent>
            </Card>
        ) : (
            <Grid container spacing={2}>
                {accounts.map((account) => (
                    <Grid item xs={12} sm={6} md={4} key={account.id}>
                        <AccountSummaryCard account={account} />
                    </Grid>
                ))}
            </Grid>
        )}
    </Box>
)

export default AccountsOverview
